import React from "react";
import { X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { useCart } from "../context/CartContext";
import CartItem from "./cart/CartItem";
import CartSummary from "./cart/CartSummary";

const CartDrawer = () => {
  const { open, setOpen, items, updateQty, updateItemVariant, removeItem, subtotal, discount, total } = useCart();
  const onQtyChange = (item, qty) => updateQty(item.product_id, item.size, item.color || "", qty);
  const onVariantChange = (item, nextSize, nextColor) => updateItemVariant(item.product_id, item.size, item.color || "", nextSize, nextColor);
  const onRemove = (item) => removeItem(item.product_id, item.size, item.color || "");

  return (
    <AnimatePresence>
      {open && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setOpen(false)}
            className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm"
          />
          <motion.aside
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{ type: "tween", duration: 0.35 }}
            className="fixed top-0 right-0 z-50 h-full w-full sm:w-[420px] bg-cynos-bg border-l border-white/10 flex flex-col"
            data-testid="cart-drawer"
          >
            <div className="flex items-center justify-between px-6 py-5 border-b border-white/10">
              <div>
                <h3 className="font-anton text-2xl uppercase">Your Cart</h3>
                <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500">{items.length} items</span>
              </div>
              <button onClick={() => setOpen(false)} aria-label="close" data-testid="cart-close-btn">
                <X size={22} />
              </button>
            </div>

            <div className="flex-1 overflow-y-auto px-6 py-4 space-y-4">
              {items.length === 0 ? (
                <div className="text-center text-zinc-500 mt-16 font-mono text-xs uppercase tracking-[0.2em]">
                  Your cart is empty.
                </div>
              ) : (
                items.map((it) => (
                  <CartItem
                    key={`${it.product_id}-${it.size}-${it.color || ""}`}
                    item={it}
                    onQtyChange={onQtyChange}
                    onVariantChange={onVariantChange}
                    onRemove={onRemove}
                    compact
                  />
                ))
              )}
            </div>

            <div className="border-t border-white/10 px-6 py-5 bg-cynos-bg">
              <CartSummary
                items={items}
                subtotal={subtotal}
                discount={discount}
                total={total}
                disabled={items.length === 0}
                onCheckoutClick={() => setOpen(false)}
              />
            </div>
          </motion.aside>
        </>
      )}
    </AnimatePresence>
  );
};

export default CartDrawer;
